module.exports = __webpack_public_path__ + "static/media/tania.dc4cf499.png";